import UserList from './pages/UserList';
import UserGroup from './pages/UserGroup';
import CustomerList from './pages/CustomerList';
import CreateFloor from './pages/CreateFloor';
import Printers from './pages/Printers';
import RestaurantList from './pages/RestaurantList';
import PaymentList from './pages/PaymentList';
import CreateCompanySetting from './pages/CreateCompanySetting';
import CategoryList from './pages/CategoryList';
import ModifierGroupList from './pages/ModifierGroupList';
import ModifiersList from './pages/ModifiersList';
import ProductList from './pages/ProductList';
import IngredientsList from './pages/Ingredients';
import Courses from './pages/Courses';
import DiscountList from './pages/DiscountList';
import ComboList from './pages/ComboList';
import ChoiceList from './pages/ChoiceList';
import DeviceList from './pages/DeviceList';
import OrderList from './pages/OrderList';
import OrderDetail from './pages/OrderDetail';
import ReportDashboard from './pages/ReportDashboard';
import ReceiptReport from './pages/ReceiptReport';
import LabourReport from './pages/LabourReport';
import HourReport from './pages/HourReport';
import MonthReport from './pages/MonthReport';
import WeekReport from './pages/WeekReport';
import DayReport from './pages/DayReport';
import ProductReport from './pages/ProductReport';
import CategoryReport from './pages/CategoryReport';
import UserReport from './pages/UserReport';
import TableReport from './pages/TableReport';
import Audit from './pages/Audit';
import PermissionsList from './pages/PermissionList';
 
export const adminRoutes = [
    {
        path: 'user/list',
        permission: "users",
        element: <UserList />
    },
    {
        path: 'user/groups',
        permission: "users",
        element: <UserGroup />
    },
    {
        path: 'user/customer',
        permission: "users",
        element: <CustomerList />
    },
    {
        path: 'floor/create',
        permission: "table-floor",
        element: <CreateFloor />
    },
    {
        path: 'printing/list',
        permission: "printers",
        element: <Printers />
    },
    {
        path: 'settings/restaurants',
        permission: "restaurant",
        element: <RestaurantList />
    },
    {
        path: 'payment/type',
        permission: "payment-methods",
        element: <PaymentList />
    },
    {
        path: 'settings/company',
        permission: "settings",
        element: <CreateCompanySetting />
    },
    {
        path: 'products/categories',
        permission: "products",
        element: <CategoryList />
    },
    {
        path: 'products/groupOfModifiers',
        permission: "products",
        element: <ModifierGroupList />
    },
    {
        path: 'products/modifiers',
        permission: "products",
        element: <ModifiersList />
    },
    {
        path: 'products/list',
        permission: "products",
        element: <ProductList />
    },
    {
        path: 'products/ingredients',
        permission: "products",
        element: <IngredientsList />
    },
    {
        path: 'products/courses',
        permission: "products",
        element: <Courses />
    },
    {
        path: 'products/discount',
        permission: "products",
        element: <DiscountList />
    },
    {
        path: 'combos/list',
        permission: "products",
        element: <ComboList />
    },
    {
        path: 'combos/choices',
        permission: "products",
        element: <ChoiceList />
    },
    // {
    //     path: 'devices/list',
    //     permission: "device",
    //     element: <DeviceList />
    // },
    {
        path: 'dashboard/view',
        element: <ReportDashboard />
    },
    {
        path: 'report/receipt',
        permission: "reports",
        element: <ReceiptReport />
    },
    {
        path: 'report/labour',
        permission: "reports",
        element: <LabourReport />
    },
    {
        path: 'report/hour',
        permission: "reports",
        element: <HourReport />
    },
    {
        path: 'report/month',
        permission: "reports",
        element: <MonthReport />
    },
    {
        path: 'report/week',
        permission: "reports",
        element: <WeekReport />
    },
    {
        path: 'report/day',
        permission: "reports",
        element: <DayReport />
    },
    {
        path: 'report/product',
        permission: "reports",
        element: <ProductReport />
    },
    {
        path: 'report/category',
        permission: "reports",
        element: <CategoryReport />
    },
    {
        path: 'report/user',
        permission: "reports",
        element: <UserReport />
    },
    {
        path: 'report/table',
        permission: "reports",
        element: <TableReport />
    },
    {
        path: 'audit/list',
        permission: "audits",
        element: <Audit />
    },
    {
        path: 'permissions',
        permission: "permissions",
        element: <PermissionsList />
    }
];